import React from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Tooltip } from '@swyftx/aviary/atoms/Tooltip/Tooltip';
import { Utility } from '@swyftx/aviary/atoms/Typography';
import { UtilityProps } from '@swyftx/aviary/atoms/Typography/Utility/Utility.styles';

import { Big } from '@shared/safe-big';
import { cn } from '@shared/utils/lib/ui';

type Props = {
  title: string;
  threshold: number;
  maxIncrement: number;
  className?: string;
  tooltip?: string;
  color?: UtilityProps['color'];
  weight?: UtilityProps['weight'];
};

const MarginAccountHealthBarThresholdItem: React.FC<Props> = ({
  title,
  tooltip,
  threshold,
  maxIncrement,
  className,
  color = 'secondary',
  weight = 'emphasis',
}) => (
  <FlexLayout
    direction='column'
    alignItems='center'
    justifyContent='center'
    style={{ width: `calc(${Big(threshold).div(maxIncrement).times(100)}% - 7px)` }}
    spacing={8}
    className='cursor-default'
  >
    <div className={cn('h-3 w-full rounded-2', className)}></div>
    <Tooltip title={tooltip} align='center' side='bottom'>
      <span>
        <Utility variant='caption' weight={weight} className='w-full truncate text-center' color={color}>
          {title}
        </Utility>
      </span>
    </Tooltip>
  </FlexLayout>
);

export { MarginAccountHealthBarThresholdItem };
